import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navigation.css";

const productLinks = [
  { label: "MediLens", slug: "medilens", desc: "エビデンス検索・分析" },
  { label: "MediLine", slug: "mediline", desc: "医薬品パイプライン検索" },
  { label: "MediAgents", slug: "mediagents", desc: "製薬業務特化AIエージェント" },
];

export const Navigation = ({ data }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isProductPage = location.pathname.startsWith('/products');

  const renderNavLink = (link, i) => {
    // Special handling for プロダクト link — add dropdown
    if (link.href === "#products") {
      return (
        <div
          key={i}
          className="nav-dropdown-wrapper"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          {isHome ? (
            <a href={link.href} className={`nav-link ${isProductPage ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
              {link.label} <span className="nav-chevron">▾</span>
            </a>
          ) : (
            <Link to="/#products" className={`nav-link ${isProductPage ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
              {link.label} <span className="nav-chevron">▾</span>
            </Link>
          )}
          <div className={`nav-dropdown ${dropdownOpen ? 'open' : ''}`}>
            {productLinks.map((p) => (
              <Link
                key={p.slug}
                to={`/products/${p.slug}`}
                className={`nav-dropdown-link ${location.pathname === `/products/${p.slug}` ? 'active' : ''}`}
                onClick={() => { setDropdownOpen(false); setMenuOpen(false); }}
              >
                <span className="nav-dropdown-name">{p.label}</span>
                <span className="nav-dropdown-desc">{p.desc}</span>
              </Link>
            ))}
          </div>
        </div>
      );
    }

    // Normal links
    if (isHome) {
      return (
        <a key={i} href={link.href} className="nav-link" onClick={() => setMenuOpen(false)}>
          {link.label}
        </a>
      );
    }
    return (
      <Link key={i} to={`/${link.href}`} className="nav-link" onClick={() => setMenuOpen(false)}>
        {link.label}
      </Link>
    );
  };

  return (
    <nav className="topbar">
      <Link className="brand" to="/" aria-label="ReCoPilot home">
        <img src="/img/logos/Logo_ReCoPilot.png" alt="" className="brand-icon" />
        <span className="brand-name">{data?.brand || "ReCoPilot"}</span>
      </Link>

      <button
        className={`menu-toggle ${menuOpen ? 'active' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span></span><span></span><span></span>
      </button>

      <div className={`topnav ${menuOpen ? 'open' : ''}`}>
        {data?.links?.map(renderNavLink)}
      </div>

      <div className="header-actions">
        <a className="demo-button" href={data?.demoUrl || "#"}>デモを申請</a>
      </div>
    </nav>
  );
};
